import TabHeadLine from './TabHeadLine';

export default TabHeadLine;
